// extracted by mini-css-extract-plugin
export var button = "_dz-0";
export var icon = "_dz-1";